import { render, staticRenderFns } from "./PasswordPage.vue?vue&type=template&id=db55128a&scoped=true"
import script from "./PasswordPage.vue?vue&type=script&lang=js"
export * from "./PasswordPage.vue?vue&type=script&lang=js"
import style0 from "./PasswordPage.vue?vue&type=style&index=0&id=db55128a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db55128a",
  null
  
)

export default component.exports